import instanceAxios from "./intanceAxios"; 

export const assetService = {
    getAssets: async (params) => await instanceAxios.get('/otask/assets/', { params })
} 